import styled from "styled-components";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const LoadingContainer = styled.div`
  padding: 15px 0;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 75px 0;
  }
`;
